<div class="loading-shade" *ngIf="isLoadingResults">
  <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div *ngIf="category$ | async as category">
  <h5>
    {{
    category
    | propertyLocalized : ["nameAr", "nameEn"]
    | async
    }}
  </h5>
  <p>
    {{
    category
    | propertyLocalized : ["descriptionAr", "descriptionEn"]
    | async
    }}
  </p>

  <app-masar-total-statistic-preview *ngIf="category.levelNumber == 1" [category]="category"></app-masar-total-statistic-preview>
  <br/>
  <app-masar-optional-inputs-preview [category]="category"></app-masar-optional-inputs-preview>
</div>